export default __webpack_public_path__ + "static/media/web.3eddece3.png";